import { observer } from 'mobx-react-lite';
import React from 'react';

import type { Billable } from '@feathr/blackbox';
import { Button, Form, FormSubmit, Input } from '@feathr/components';

interface IProps {
  billable: Billable;
  onPrevious: () => void;
  onSave: (model: Billable) => void;
  saveButtonText?: string;
}

function BillableStepFour({
  billable,
  onPrevious,
  onSave,
  saveButtonText = 'Save Changes',
}: IProps) {
  const refs = { description: React.useRef<HTMLInputElement>(null) };

  return (
    <Form
      actions={[
        <FormSubmit<Billable>
          key={'next'}
          method={billable.isEphemeral ? 'add' : 'patch'}
          model={billable}
          onClick={onSave}
          refs={refs}
          save={true}
        >
          {saveButtonText}
        </FormSubmit>,
        <Button key={'previous'} onClick={onPrevious} type={'naked'}>
          Previous
        </Button>,
      ]}
      label={'Billing configuration settings: Description'}
    >
      <Input
        attribute={'description'}
        helpText={'Used as the label for this billing configuration thoughout the site.'}
        label={'Description'}
        model={billable}
        optional={true}
        ref={refs.description}
        type={'text'}
      />
    </Form>
  );
}

export default observer(BillableStepFour);
